import { Languages } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LOCALES, type Locale } from "./types";
import { useI18n } from "./I18nContext";
import { cn } from "@/lib/utils";

export function LanguageSwitcher({ className }: { className?: string }) {
  const { locale, setLocale, t } = useI18n();

  return (
    <div
      className={cn("flex items-center gap-1", className)}
      role="group"
      aria-label={t("app.language")}
    >
      <Languages className="h-3.5 w-3.5 text-muted-foreground mr-1" />
      {LOCALES.map((item) => (
        <Button
          key={item.code}
          size="sm"
          variant={locale === item.code ? "default" : "ghost"}
          className="h-7 px-2 text-xs font-medium"
          onClick={() => setLocale(item.code as Locale)}
          aria-pressed={locale === item.code}
        >
          {item.code === "vi" ? "VI" : "EN"}
        </Button>
      ))}
    </div>
  );
}
